export default __webpack_public_path__ + "static/media/monitor_800.ae8df87c.gif";